//
// Fixes various aspects of the report viewer
//
//  BenRamey
//  February 2011
//
HEIJS.registerNamespace("HEIJS.Controls.ReportingServices");
HEIJS.Controls.ReportingServices.ReportViewerStyler = function () {
  var location = String(document.location);
  var doVerticalHeaderAdjustment = location.search("ProjectAdminReport") > -1
    || location.search("CoordinationReport") > -1;
  // remove extraneous spacer at bottom of page
  $("div.ms-PartSpacingVertical").remove();

  var configReportSizes = function () {
    if (doVerticalHeaderAdjustment) {
      $("table[id$=ReportViewer_fixedTable] div").each(
          function () {
            if ($(this).css("writing-mode") == "tb-rl") {
              var text = $(this).text();

              $(this).empty().text(text);

              $(this).parent().css({
                "height": "130px",
                "padding": "4px",
                "position": "relative"
              });
              $(this).css({
                "font-family": "Tahoma",
                "font-size": "10px",
                "font-weight": "400",
                "layout-flow": "vertical-ideographic",
                "writing-mode": "",
                "min-width": "",
                "height": "130px",
                "text-align": "right",
                "position": "absolute",
                "bottom": 0,
                "right": 0,
                "padding": "4px"
              });
            }
          });
    }

    // set viewer height correctly
    var centerPanelCell = $("td[id$=CenterPanelCell]").addClass("auto-adjusts-height-to-page");
    centerPanelCell.css({
      "overflow-y": "visible",
      "overflow": "visible"
    });
    HEIJS.controls.resizeControls(centerPanelCell);

    var fixedTable = $("table[id$=ReportViewer_fixedTable]").scrollTop(0);
    var reportDivWidth = fixedTable.parents("td:first").width();
    if (reportDivWidth != null) {
      // if the doc map cells are showing
      if ($("table[id$=ReportViewer_fixedTable] span[id$=ReportViewer_DocMap]>div").children().length > 1) {
        // reduce the width by the sum of the docmap and the separater cell 150+6
        if ($("table[id$=ReportViewer_fixedTable] span[id$=ReportViewer_DocMap]").is(":visible"))
          reportDivWidth -= 156;
        else
          reportDivWidth -= 6;
      }
    }

    // report div
    var reportDiv = $("div[id$=ReportDiv]");
    if (!reportDiv.hasClass("auto-adjusts-height-to-page")) {
      reportDiv.addClass("auto-adjusts-height-to-page");
      reportDiv.css("overflow", "auto");
    }
    if (reportDivWidth != null) {
      reportDiv.width(reportDivWidth);
    }
    HEIJS.controls.resizeControls(reportDiv);

    // doc map div 
    var docMapDiv = $("span[id$=ReportViewer_DocMap] div[id$=RootNode]").parent();
    if (!docMapDiv.hasClass("auto-adjusts-height-to-page")) {
      docMapDiv.addClass("auto-adjusts-height-to-page");
      docMapDiv.css("overflow", "auto");
    }
    HEIJS.controls.resizeControls(docMapDiv);
  };

  configReportSizes();
  $(window).resize(function () { configReportSizes(); });

  if (Microsoft.ReportingServices) { // sharepoint namespace for report viewer webpart
    Microsoft.ReportingServices.SharePoint.WebPartClient._ReportViewerWebPart.prototype.GetTargetHeight =
      function () {
        var parameterTable = $("[id$=PromptAreaUpdatePanel] table:first");
        var height = parameterTable.length > 0 ? parameterTable.height() : 110;
        return height;
      };

    var OnResize_old = Microsoft.ReportingServices.SharePoint.WebPartClient._ReportViewerWebPart.prototype.OnResize;
    Microsoft.ReportingServices.SharePoint.WebPartClient._ReportViewerWebPart.prototype.OnResize =
      function () {
        var retVal = OnResize_old.apply(this);
        configReportSizes();
        return retVal;
      };
  }

  var ResizeViewerReportUsingContainingElement_old = Microsoft.Reporting.WebFormsClient._InternalReportViewer.prototype.ResizeViewerReportUsingContainingElement;
  Microsoft.Reporting.WebFormsClient._InternalReportViewer.prototype.ResizeViewerReportUsingContainingElement =
    function () {
      var retVal = ResizeViewerReportUsingContainingElement_old.apply(this);
      configReportSizes();
      return retVal;
    };

  var OnTreeNodeSelected_old = Microsoft.Reporting.WebFormsClient._DocMapArea.prototype.OnTreeNodeSelected;
  Microsoft.Reporting.WebFormsClient._DocMapArea.prototype.OnTreeNodeSelected =
    function (treeNode) {
      var reportDiv = $("div[id$=ReportDiv]");
      var docMapId = treeNode.attributes.getNamedItem("DocMapId").value;
      this.MarkNodeAsSelected(treeNode);

      var span = reportDiv.find("[id$=" + docMapId + "]");
      if (span.length > 0) {
        reportDiv.scrollTop(reportDiv.scrollTop() + (span.offset().top - reportDiv.offset().top));
      }
      else {
        OnTreeNodeSelected_old.apply(this, arguments);
      }
    };

  Microsoft.Reporting.WebFormsClient._ReportArea.prototype.BringElementIntoView =
  Microsoft.Reporting.WebFormsClient._ReportArea.prototype.ScrollWebForm =
    function (navigationId) {
      configReportSizes();
      var reportDiv = $("div[id$=ReportDiv]");
      var span = reportDiv.find("#" + navigationId);

      setTimeout(function() {
        window.location.replace("#" + navigationId);
        if (span.length > 0) {
          reportDiv.scrollTop(reportDiv.scrollTop() + (span.offset().top - reportDiv.offset().top));
        }
      }, 100);
    };

  var SetDocMapAreaVisibility_old = Microsoft.Reporting.WebFormsClient._InternalReportViewer.prototype.SetDocMapAreaVisibility;
  var clickCounter = 0;
  Microsoft.Reporting.WebFormsClient._InternalReportViewer.prototype.SetDocMapAreaVisibility = function () {
    var cell = $("td.sqlrv-SplitterNormal,td.sqlrv-SplitterHover").prev("td");
    var reportDiv = $("div[id$=ReportDiv]");
    SetDocMapAreaVisibility_old.apply(this, arguments);

    if (clickCounter % 2 == 0) {
      cell.children("div").hide();
      cell.width(1);
      reportDiv.width(reportDiv.width() + 149);
    }
    else {
      cell.children("div").show();
      cell.width(150);
      reportDiv.width(reportDiv.width() - 149);
    }

    clickCounter++;
  };
};

$(document).ready(
	function () {
	  // check if this page has a report on it
	  if ($("div[rsviewer],span[id$=ReportViewer_ReportViewer]").length > 0) {
	    new HEIJS.Controls.ReportingServices.ReportViewerStyler();
	  }
	});